"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _alignmentTypes = _interopRequireDefault(require("../../../../constants/alignmentTypes"));

var _card = require("../../../../styles/2_commonComponentStyles/card");

var _Card = require("./Card.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The Card component... This guy is a bit of a WIP as we feel out how we would like to use these elements.
 * As such, you may not find things here to be perfect, or maybe over-engineered.
 * If you find that any of these shortcomings get in the way of use, let's have a chat!
 *
 * If you omit the Title, the card will present itself with just body content,
 * but will apply the header background color to the card.
 *
 * There is not a way to color the body of the card if you provide a Title at this point in time.
 */
var Card = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Card, _React$PureComponent);

  var _super = _createSuper(Card);

  function Card() {
    _classCallCheck(this, Card);

    return _super.apply(this, arguments);
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          noBorder = _this$props.noBorder,
          className = _this$props.className,
          colorTheme = _this$props.colorTheme,
          dataTestId = _this$props.dataTestId,
          withShadow = _this$props.withShadow,
          textAlign = _this$props.textAlign,
          title = _this$props.title;
      return /*#__PURE__*/_react.default.createElement(_Card.StyledCard, {
        className: className,
        "data-test-id": dataTestId,
        colorTheme: colorTheme,
        withShadow: withShadow,
        textAlign: textAlign,
        noBorder: noBorder && !title
      }, title && /*#__PURE__*/_react.default.createElement(_Card.StyledCardHeader, {
        dataTestId: "".concat(dataTestId, "-header"),
        colorTheme: colorTheme,
        fullWidth: true
      }, this.props.title), /*#__PURE__*/_react.default.createElement(_Card.StyledCardBody, {
        dataTestId: "".concat(dataTestId, "-content"),
        colorTheme: colorTheme,
        hasTitle: !!title
      }, this.props.children));
    }
  }]);

  return Card;
}(_react.default.PureComponent);

_defineProperty(Card, "propTypes", {
  /** Flag for overriding application of the border - on by default for all components with a header */
  noBorder: _propTypes.default.bool,

  /** Content */
  children: _propTypes2.default.children.isRequired,

  /** Hook for overriding top-level component styles */
  colorTheme: _propTypes.default.oneOf(_card.cardColorThemes),

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag to enable a drop shadow */
  withShadow: _propTypes.default.bool,

  /** Title that gets displayed in card header */
  title: _propTypes.default.string,

  /** alignment of header and content */
  textAlign: _propTypes.default.oneOf(_alignmentTypes.default)
});

_defineProperty(Card, "defaultProps", {
  noBorder: false,
  className: '',
  colorTheme: 'default',
  withShadow: false,
  textAlign: 'left',
  title: undefined
});

var _default = Card;
exports.default = _default;